module.exports = "<h1>Contract stub to go here</h1>\n<p>Gotta find a good one to use first.</p>\n";